<template>
  <div class="flex flex-col min-h-screen">
    <div
      class="grid grid-cols-6 sm:grid-cols-6 md:grid-cols-6 lg:grid-cols-6 xl:grid-cols-6"
    >
      <div
        class="hidden sm:hidden md:hidden lg:grid xl:grid lg:col-span-1 xl:col-span-1"
      ></div>
      <div
        class="col-span-6 lg:grid xl:grid lg:col-span-4 xl:col-span-4 mt-0 sm:mt-0 md:mt-0 lg:mt-4 xl:mt-4 mx-0 sm:mx-0 md:mx-0 lg:mx-2 xl:mx-2"
      >
        <Login />
      </div>
      <div class="col-span-6 lg:grid xl:grid lg:col-span-1 xl:col-span-1"></div>
    </div>

    <div class="flex flex-grow">
      <Footer />
    </div>
  </div>
</template>

<script>
import Login from "../components/Auth/Login";

import Footer from "../components/Footer";

export default {
  components: {
    Footer,
    Login,
  },
  data() {
    return {
      //   hideResults: true
    };
  },
};
</script>
